import { combineReducers } from 'redux';

import repeatedFrom from 'state/mrCollection/repeated-from';
import shipments from 'state/mrCollection/shipments';
import extras from 'state/mrCollection/extras';
import quote from 'state/mrCollection/quote';
import ui from 'state/mrCollection/ui';

const data = combineReducers({
  shipments,
  extras,
  repeatedFrom,
});

const reducer = combineReducers({
  data,
  ui,
  quote,
});

export default reducer;
